import Modal from './Modal';
import _template from 'lodash/template';
import { BREAKPOINT } from '../constants';
import itemContentTpl from '../templates/proj-gallery/item-content';
import ytTpl from '../templates/proj-gallery/youtube';
import vimeoTpl from '../templates/proj-gallery/vimeo';
class ModalProjGallery extends Modal {
  constructor(el, data){
    super(el, data);

    this.data = data;
    this.modal = this;
  }

  setupDefaults(){
    this.dom.$container = $('<div><ul class="modal--proj-gallery__list"></ul></div>');
    this.dom.$list = this.dom.$container.find('.modal--proj-gallery__list');
    this.dom.$sociallinks = this.$el.parents('.proj-gallery').find('.proj-gallery__social-links');
  }

  onOpenModal(e) {
    super.onOpenModal(e);

    this.initialSlide = $(e.currentTarget).data('modalIndex');
  }

  getContent() {
    const { products } = this.data;

    products.forEach((product, index) => {
      let galleryMedia;
      product.index = index;
      product.total = products.length;

      if (product.videoId) {
        switch (product.videoType) {
        case 'youtube':
          galleryMedia = _template(ytTpl)({ videoId: product.videoId, title: product.title });
          break;
        case 'vimeo':
          galleryMedia = _template(vimeoTpl)({ videoId: product.videoId, title: product.title });
          break;
        default:
          break;
        }
      }

      this.dom.$list.append(_template(itemContentTpl)({ galleryMedia, product }));
    });

    this.dom.$container.append(this.dom.$sociallinks.html());

    return { content: this.dom.$container.html() };
  }

  showModal() {
    super.showModal();

    $('#modal').addClass('modal--proj-gallery');
    this.dom.$list = this.dom.$modalContent.find('.modal--proj-gallery__list');
    this.initSlick();
  }

  initSlick() {

    this.dom.$list.on('init', slick => {
      slick = $(slick.currentTarget);
      this.checkLoadedVideos(slick);
      this.playPauseVideo(slick, 'play');
      this.updateSocialLinks(slick);
    });

    this.dom.$list.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      slick = $(slick.$slider);
      this.playPauseVideo(slick, 'pause');
      this.updateSocialLinks(slick, nextSlide);
    });

    this.dom.$list.on('afterChange', (event, slick) => {
      slick = $(slick.$slider);
      this.playPauseVideo(slick, 'play');
    });

    this.dom.$list.slick({
      infinite: false,
      arrows: true,
      prevArrow: '<img class="slick-prev slick-arrow" src="/dist/sites/cc/images/contentManaged/icons/icon-arrow-left-shadow.svg" alt="prev slide">',
      nextArrow: '<img class="slick-next slick-arrow" src="/dist/sites/cc/images/contentManaged/icons/icon-arrow-right-shadow.svg" alt="next slide">',
      slidesToShow: 1,
      lazyLoad: 'ondemand',
      initialSlide: this.initialSlide,
      adaptiveHeight: true
    });
  }

  checkLoadedVideos(slick) {
    slick.find('.modal--proj-gallery').each((i, e) => {
      const player = $(e).find('iframe').get(0);

      if (player) {
        $(player).on('load', e => $(e.target).addClass('proj-gallery__video-loaded'));
      }
    });
  }

  postMessageToPlayer(player, command) {
    player.contentWindow.postMessage(JSON.stringify(command), '*');
  }

  playPauseVideo(slick, control) {
    const currentSlide = slick.find('.slick-current');
    const slideType = currentSlide.attr('class').split(' ')[1];
    const player = currentSlide.find('iframe').get(0);

    if (!player) return;

    if (!$(player).hasClass('proj-gallery__video-loaded')) {
      setTimeout(() => this.playPauseVideo(slick, control), 1000);
      return;
    }

    if (slideType === 'vimeo') {
      switch (control) {
      case 'play':
        this.postMessageToPlayer(player, { method: 'play', value : 1 });
        break;
      case 'pause':
        this.postMessageToPlayer(player, { method: 'pause', value: 1 });
        break;
      }
    } else if (slideType === 'youtube') {
      switch (control) {
      case 'play':
        this.postMessageToPlayer(player, { event: 'command', func: 'playVideo' });
        break;
      case 'pause':
        this.postMessageToPlayer(player, { event: 'command', func: 'pauseVideo' });
        break;
      }
    }
  }

  updateSocialLinks(slick, nextSlide) {
    const shareInfo = {};
    let currentSlide = slick.find('.slick-current');

    if (nextSlide) {
      currentSlide = slick.find(`[data-slick-index='${nextSlide}']`);
    }

    shareInfo['url'] = `${window.location.origin}${window.location.pathname}#${currentSlide.data('guid')}`;
    shareInfo['media'] = `${window.location.origin}${currentSlide.data('media')}`;
    shareInfo['title'] = currentSlide.find('.modal--proj-gallery__title').text();
    shareInfo['description'] = currentSlide.find('.modal--proj-gallery__description').text();

    for(const key in shareInfo) {
      if ({}.hasOwnProperty.call(shareInfo, key)) {
        this.dom.$modalContent.find('.addthis_share_button').attr(`data-${key}`, shareInfo[key]);
      }
    }
  }
}

export default ModalProjGallery;



// WEBPACK FOOTER //
// ./src/cc/js/components/ModalProjGallery.js